module.exports = {"511112100":"竹根镇","511112101":"牛华镇","511112102":"杨柳镇","511112103":"桥沟镇","511112104":"金粟镇","511112105":"金山镇","511112106":"辉山镇","511112107":"西坝镇","511112108":"冠英镇","511112109":"蔡金镇","511112110":"石麟镇","511112200":"新云乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511112.json
// module id = 2148
// module chunks = 0